var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2706 8H15.7301C14.704 8 13.72 8.4076 12.9945 9.13313C12.2689 9.85866 11.8613 10.8427 11.8613 11.8687V33.1468C11.8613 34.1728 12.2689 35.1569 12.9945 35.8824C13.72 36.6079 14.704 37.0155 15.7301 37.0155H29.2706C30.2967 37.0155 31.2807 36.6079 32.0063 35.8824C32.7318 35.1569 33.1394 34.1728 33.1394 33.1468V11.8687C33.1394 10.8427 32.7318 9.85866 32.0063 9.13313C31.2807 8.4076 30.2967 8 29.2706 8ZM31.205 33.1468C31.205 33.6598 31.0012 34.1518 30.6385 34.5146C30.2757 34.8774 29.7837 35.0812 29.2706 35.0812H15.7301C15.217 35.0812 14.725 34.8774 14.3623 34.5146C13.9995 34.1518 13.7957 33.6598 13.7957 33.1468V11.8687C13.7957 11.3557 13.9995 10.8637 14.3623 10.5009C14.725 10.1382 15.217 9.93437 15.7301 9.93437H29.2706C29.7837 9.93437 30.2757 10.1382 30.6385 10.5009C31.0012 10.8637 31.205 11.3557 31.205 11.8687V33.1468Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3726 31.2129H18.6352C18.3786 31.2129 18.1326 31.3148 17.9513 31.4962C17.7699 31.6776 17.668 31.9236 17.668 32.1801C17.668 32.4366 17.7699 32.6826 17.9513 32.864C18.1326 33.0454 18.3786 33.1473 18.6352 33.1473H26.3726C26.6291 33.1473 26.8752 33.0454 27.0565 32.864C27.2379 32.6826 27.3398 32.4366 27.3398 32.1801C27.3398 31.9236 27.2379 31.6776 27.0565 31.4962C26.8752 31.3148 26.6291 31.2129 26.3726 31.2129Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.5e35440a1e77fdbe0fd187ab8253d9e2.svg";
export { ForwardRef as ReactComponent };